











































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import Modal from '@/components/Modal'

import AudienceCreativeResourceList from '@superComponents/AudienceCreative/AudienceCreativeResourceList'
import VenueResourceList from '@superComponents/Venue/VenueResourceList'
import OfferResourceList from '@superUI/ResourceList/OfferResourceList'
import OrganizerResourceList from '@superUI/ResourceList/OrganizerResourceList'
import SupplierResourceList from '@superUI/ResourceList/SupplierResourceList'
import RemittanceResourceList from '@superUI/ResourceList/RemittanceResourceList'
import FlagsAndTags from '@superUI/FlagsAndTags'
import PricingTable from '@ui/Event/PricingTable'
import UpdatePricingModelTriggerModal from '@triggers/Event/UpdatePricingModelTriggerModal'
import AddMemberNoteTriggerModal from '@triggers/Utils/AddMemberNoteTriggerModal'
import AddSuperNoteTriggerModal from '@triggers/Utils/AddSuperNoteTriggerModal'
import AcceptPendingOffersTriggerModal from '@triggers/Supplier/AcceptPendingOffersTriggerModal'
import AddAudiencePartnershipTriggerModal from '@triggers/Supplier/AddAudiencePartnershipTriggerModal'
import MergeSupplierTopOrgsTriggerModal from '@triggers/Supplier/MergeSupplierTopOrgsTriggerModal'
import MergeSupplierTeamsTriggerModal from '@triggers/Supplier/MergeSupplierTeamsTriggerModal'
import AcceptPendingOfferTriggerModal from '@triggers/Offer/AcceptPendingOfferTriggerModal'

settings =
  name: 'SupplierShow'

  components: {
    SuperContainerView,
    Back,
    Modal,
    AudienceCreativeResourceList,
    VenueResourceList,
    OfferResourceList,
    OrganizerResourceList,
    SupplierResourceList,
    RemittanceResourceList,
    FlagsAndTags,
    AddMemberNoteTriggerModal,
    AddSuperNoteTriggerModal,
    PricingTable,
    UpdatePricingModelTriggerModal,
    AcceptPendingOffersTriggerModal,
    AddAudiencePartnershipTriggerModal,
    MergeSupplierTopOrgsTriggerModal,
    MergeSupplierTeamsTriggerModal,
    AcceptPendingOfferTriggerModal,
  }

  resources:
    item:
      resourceName: 'supplier'
      slug: 'suppliers/:supplierId'
    audience_creatives:
      resourceName: 'audience_creative'
      slug: 'suppliers/:supplierId/audience_creatives'
      infinityScroll: true
    venues:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/venues'
      infinityScroll: true
    offers:
      resourceName: 'offers'
      slug: 'suppliers/:supplierId/offers'
      infinityScroll: true
    organizers:
      resourceName: 'organizers'
      slug: 'suppliers/:supplierId/organizers'
      infinityScroll: true
    teams:
      resourceName: 'suppliers'
      slug: 'suppliers/:supplierId/suppliers'
      infinityScroll: true
    remittances:
      resourceName: 'remittances'
      slug: 'suppliers/:supplierId/remittances'
      infinityScroll: true

  vue:
    props: ['supplierId']

    data: ->
      switchUserModal:
        show: false
        rep: null

      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

    computed:
      offerCount: ->
        @item.ctx["stats"]["offer"]["pending_count"]

      verifiedBadgeSrc: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

      audiencePartnershipIds: -> @item.audience_partnership_ids || []
      hasAudiencePartnership: -> !!@audiencePartnershipIds[0]

      memberNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_member_note', component: this }
      superNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_super_note', component: this }

      memberNotePayload: ->
        payload =
          options:
            note: ""
        payload
      superNotePayload: ->
        payload =
          options:
            note: ""
        payload

      publicTagTriggerResource: ->
        { key: 'item', triggerName: 'add_public_tag', component: this }
      privateTagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_tag', component: this }
      untagTriggerResource: ->
        { key: 'item', triggerName: 'untag', component: this }
      privateStatusFlagTriggerResource: ->
        { key: 'item', triggerName: 'add_private_status_flag', component: this }
      unflagTriggerResource: ->
        { key: 'item', triggerName: 'unflag', component: this }

      actionsForPricingModel: ->
        {
          @hiUpdatePricingModelTrigger,
          @hiRemoveSpecialPricingTrigger
        }

      optionsForAudienceCreatives: ->
        supplierId: @item.id

      actionsForAudienceCreatives: ->
        fetchResource: @fetchResource
        bulkEdit: @bulkEditAudienceCreatives
        preview: @previewAudienceCreative
        show: @showAudienceCreative
        edit: @editAudienceCreative

      actionsForVenues: ->
        fetchResource: @fetchResource
        bulkEdit: @bulkEditVenues

    methods:
      badgePotential: (item) ->
        return 'unconfirmed' if item.potential_unconfirmed
        return 'confirmed' if item.potential_confirmed
        return 'denied' if item.potential_denied

      badgeState: (item) ->
        return item.state

      badgePublished: (item) ->
        if item.published then 'published' else 'unpublished'

      badgeHorizon: (item) ->
        item.horizon

      hiNavigateToAudiencePartnership: ->
        audiencePartnershipId = @audiencePartnershipIds[0]
        @$router.push { name: 'AudiencePartnershipShowPage', params: { audiencePartnershipId } }
      hiAddAudiencePartnership: ->
        payloadOptions = {}
        modalOptions = { item: @item }
        @$refs.addAudiencePartnershipTrigger.fire payloadOptions, modalOptions
      onItemAddAudiencePartnership: ->
        @$refs.addAudiencePartnershipTrigger.close()

      hiPromptToSwitchUser: (rep) ->
        event.stopPropagation()
        @switchUserModal.rep = rep
        @switchUserModal.show = true

      hiSwitchUser: (rep) ->
        @switchUserModal.show = false
        @switchUser rep.member_id

      hiGeneratePersonaReport: ->
        @triggerResource 'item', 'generate_persona_report'
      onItemGeneratePersonaReport: ->

      hiMergeSupplierTopOrgs: ->
        payloadOptions = {}
        modalOptions = { supplier: @item }
        @$refs.mergeSupplierTopOrgsTrigger.fire payloadOptions, modalOptions
      onItemMergeTopOrgs: ->
        @$refs.mergeSupplierTopOrgsTrigger.close()

      hiMergeSupplierTeams: ->
        payloadOptions = {}
        modalOptions = { supplier: @item }
        @$refs.mergeSupplierTeamsTrigger.fire payloadOptions, modalOptions
      onItemMergeTeams: ->
        @$refs.mergeSupplierTeamsTrigger.close()

      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      onItemAddMemberNote: -> @fetch('item')
      onItemAddSuperNote: -> @fetch('item')
      onItemAddPublicTag: -> @fetch('item')
      onItemAddPrivateTag: -> @fetch('item')
      onItemUntag: -> @fetch('item')
      onItemAddPrivateStatusFlag: -> @fetch('item')
      onItemUnflag: -> @fetch('item')

      triggerAddMemberNote: -> @$refs.addMemberNoteTrigger.fire()
      triggerAddSuperNote: -> @$refs.addSuperNoteTrigger.fire()

      onItemAddMemberNote: ->
        @fetch('item')
        @$refs.addMemberNoteTrigger.close()

      onItemAddMemberNoteError: (key, event, action, data, response) ->
        @showError('Could not add note')
      
      onItemAddSuperNote: ->
        @fetch('item')
        @$refs.addSuperNoteTrigger.close()

      onItemAddSuperNoteError: (key, event, action, data, response) ->
        @showError('Could not add note')

      hiUpdatePricingModelTrigger: (pricingModel, pricing) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, pricing }
        @$refs.updatePricingModelTrigger.fire(payloadOptions, modalOptions)
      hiRemoveSpecialPricingTrigger: (pricingModel) ->
        @triggerResource 'item', 'update_pricing_model', { pricing_model: pricingModel }
      onItemUpdatePricingModel: (data, response) ->
        @$refs.updatePricingModelTrigger.close()
        @fetch('item')

      bulkEditAudienceCreatives: (audienceCreatives) ->
        query = { audienceCreatives }
        @$router.push { name: 'SupplierAudienceCreativeBulkEditPage', query }

      previewAudienceCreative: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        @$router.push { name: 'SupplierAudienceCreativePreviewPage', params }

      showAudienceCreative: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        @$router.push { name: 'AudienceCreativeShowPage', params }

      editAudienceCreative: (audienceCreative) ->
        params = { audienceCreativeId: audienceCreative.id }
        query = { step: 'experience' }
        @$router.push { name: 'AudienceCreativeEditPage', params, query }

      bulkEditVenues: (venues) ->
        query = { venues }
        @$router.push { name: 'SupplierVenueBulkEditPage', query }

      hiAcceptPendingOffersTrigger: ->
        payloadOptions = {}
        modalOptions = {item: @item}
        @$refs.acceptPendingOffersTrigger.fire(payloadOptions, modalOptions)
      onItemAcceptPendingOffers: ->
        @$refs.acceptPendingOffersTrigger.close()

      acceptPendingOfferTrigger: (offer) ->
        payloadOptions = { offer_id: offer.id }
        modalOptions = { offer }
        @$refs.acceptPendingOfferTrigger.fire(payloadOptions, modalOptions)
      onOffersAgreeToTermsAndAccept: ->
        @$refs.acceptPendingOfferTrigger.close()

    watch:
      $route: ->
        @fetchAllResources()

export default VueOptions.vue settings
